import React from 'react';
import Navbar from './NavbarComponent';

function Header() {
    return (
        <Navbar />
    );
}

export default Header;
